/* LIST_TYPE is used by both legacy & 2023 slider. getByCmsName is used by legacy only. */
const LIST_TYPE = {
  SPOILER: 0,
  0: {
    cmsName: "spoiler",
    id: 0,
    listUri: "/api/product/list/spoiler/${setId}",
    name: "Spoiler List",
    titleUri: "/catalog/view/${setId}",
  },
  HOT_BUY: 1,
  1: {
    cmsName: "hotbuy",
    id: 1,
    listUri: "/api/product/list/hotbuy",
    name: "Hot Buy List",
    titleUri: "/purchasing/mtg_singles?utm_campaign=hotbuylist",
  },
  getByCmsName(cmsName) {
    let idx = 0;
    while (this[idx]) {
      if (this[idx].cmsName === cmsName) {
        return this[idx];
      }
      ++idx;
    }
  },
};

/* BREAKPOINTS keys are used for dynamic sizing logic in vue components. */
/* values should mirror bootstrap/css breakpoints for media-queries */
const BREAKPOINTS = {
  xs: 0,
  sm: 584,
  md: 776,
  lg: 1016,
  xl: 1208,
  xxl: 1400,
  xxxl: 1920,
  xxxxl: 2400,
};

/* all SLIDER_TYPES needs only add variations from default. */
/* if an attribute with an object for value is overridden, the ENTIRE object must be defined */
/* xs is smallest view, and is used as default. xs MUST be defined.  */
/* Only changes between breakpoints need to be defined. if a breakpoint uses same value as smaller view, it can be skipped */

const SLIDER_TYPES = {
  default: {
    hasBreadcrumbs: true,
    hasControlArrows: true,
    hasShowAllLink: true,
    imageProportionClass: {
      xs: "shape-mtg-card"
    },
    infoPanelHeight: {
      xs: 3.75
    },
    infoPanelParameters: [
      'edition',
      'price_buy',
      'price_sale',
      'price',
      'name'
    ],
    itemsPerPage: {
      xs: 2,
      md: 4,
      lg: 6,
    },
    itemType: "default", // "mtg-card",
    marginWidth: {
      xs: 16,
      lg: 24
    },
  },
  blog: {
    hasBreadcrumbs: true,
    hasControlArrows: true,
    hasShowAllLink: true,
    marginWidth: {
      xs: 24
    },
    imageProportionClass: {
      xs: "shape-sixteen-by-nine"
    },
    infoPanelHeight: {
      xs: 10.375
    },
    infoPanelParameters: [
      'edition',
      'name',
      'description',
    ],
    itemsPerPage: {
      xs: 1,
      md: 2,
      lg: 3,
    },
    itemType: "blog",
  },
  featuredProduct: {
    itemsPerPage: {
      xs: 2,
      md: 4,
    }
  },
  gradedMagic: {
    imageProportionClass: {
      xs: "shape-graded-magic-card",
    },
  },
  hero: {
    imageProportionClass: {
      xs: "shape-sixteen-by-nine",
      md: "shape-twentyone-by-nine"
    },
    infoPanelHeight: {
      xs: 0,
    },
    infoPanelParameters: [],
    itemsPerPage: {
      xs: 1,
    },
    itemType: "hero",
    marginWidth: {
      xs: 0,
    }
  },
  LatestEditions: {
    hasBreadcrumbs: false,
    hasControlArrows: false,
    hasShowAllLink: false,
    imageProportionClass: {
      xs: "shape-square",
    },
    infoContentFields: [
      "title",
    ],
    infoPanelHeight: {
      xs: 2.5
    },
    infoPanelParameters: [
      'name',
    ],
    itemType: "LatestEditions",
    marginWidth: {
      xs: 24,
    }
  },
  sealedProductOnly: {
    hasBreadcrumbs: true,
    hasControlArrows: true,
    hasShowAllLink: true,
    imageProportionClass: {
      xs: "shape-square",
    }
  },
};


/*
  SLIDER_ITEM_TYPES NOTES
  any property that is set fully overrides all defaults for that property

  breakpoints always look from  'xs' -> 'xxxxl'
  only changes between breakpoints need to be included
  Breakpoint keys and width
      xs: 0px
      sm: 584px
      md: 776px
      lg: 1016px
      xl: 1208px
      xxl: 1400px
      xxxl: 1920px
      xxxxl: 2400px

 */

const SLIDER_ITEM_TYPES = {
  default: {
    infoContentFields: [
      "category",
      "price",
      "priceSale",
      "title",
    ]
  },
  discountedProduct: {
    infoPanelParameters: [
      "edition",
      "name",
      "priceSale",
      "price",
    ],
  },
  hotbuyProduct: {
    infoPanelParameters: [
      "edition",
      "name",
      "priceBuy",
      "price",
    ],
  },
  latestEditions: {},
  mtgCard: {},
  sealedProduct: {},
  sealedProductOnly: {},
  featuredProduct: {},
  blog: {
    infoContentFields: [
      "badge",
      "header",
      "detailText",
      "title",
    ],
  },
  hero: {
    infoContentFields: []
  },
};

export {
  BREAKPOINTS, LIST_TYPE, SLIDER_TYPES, SLIDER_ITEM_TYPES
};
